/**
 * GWH Compare — client-side (localStorage) watch comparison.
 * Max 3 watches. Sticky bar + side-by-side drawer.
 */
(function () {
  'use strict';

  var KEY = 'gwh-compare';
  var MAX = 3;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return read().some(function (p) {
      return p.handle === handle;
    });
  }

  function toggle(item) {
    var list = read();
    var exists = list.some(function (p) {
      return p.handle === item.handle;
    });
    if (exists) {
      list = list.filter(function (p) {
        return p.handle !== item.handle;
      });
    } else {
      if (list.length >= MAX) {
        announce('You can compare up to ' + MAX + ' watches. Remove one first.');
        return null;
      }
      list.push(item);
    }
    write(list);
    return !exists;
  }

  function remove(handle) {
    write(
      read().filter(function (p) {
        return p.handle !== handle;
      })
    );
  }

  function clear() {
    write([]);
  }

  function itemFromButton(btn) {
    return {
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      vendor: btn.getAttribute('data-vendor') || '',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      available: btn.getAttribute('data-available') !== 'false'
    };
  }

  function safeUrl(url) {
    if (typeof url !== 'string') return '#';
    var u = url.trim();
    return /^(https?:\/\/|\/|\.\/)/i.test(u) ? u : '#';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function announce(msg) {
    var live = document.querySelector('[data-gwh-compare-live]');
    if (!live) {
      live = el('div', 'visually-hidden');
      live.setAttribute('data-gwh-compare-live', '');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = msg;
    }, 10);
  }

  function syncButtons() {
    document.querySelectorAll('[data-gwh-compare-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var on = has(handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var title = btn.getAttribute('data-title') || 'watch';
      btn.setAttribute('aria-label', (on ? 'Remove from compare: ' : 'Compare ') + title);
    });
  }

  function renderBar() {
    var bar = document.querySelector('[data-gwh-compare-bar]');
    if (!bar) return;
    var list = read();
    var countEl = bar.querySelector('[data-gwh-compare-count]');
    var thumbs = bar.querySelector('[data-gwh-compare-thumbs]');
    var openBtn = bar.querySelector('[data-gwh-compare-open]');

    if (countEl) countEl.textContent = String(list.length);
    if (thumbs) {
      thumbs.textContent = '';
      list.forEach(function (p) {
        var wrap = el('button', 'gwh-compare-bar__thumb');
        wrap.type = 'button';
        wrap.setAttribute('data-gwh-compare-remove', p.handle || '');
        wrap.setAttribute('aria-label', 'Remove ' + (p.title || 'watch'));
        if (p.image) {
          var img = document.createElement('img');
          img.src = safeUrl(p.image);
          img.alt = '';
          img.width = 48;
          img.height = 48;
          wrap.appendChild(img);
        }
        thumbs.appendChild(wrap);
      });
    }
    if (openBtn) openBtn.disabled = list.length < 2;
    bar.hidden = list.length === 0;
    document.documentElement.classList.toggle('gwh-compare-active', list.length > 0);
  }

  function renderDrawer() {
    var grid = document.querySelector('[data-gwh-compare-grid]');
    var empty = document.querySelector('[data-gwh-compare-empty]');
    if (!grid) return;
    var list = read();
    grid.textContent = '';

    if (!list.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    list.forEach(function (p) {
      var col = el('article', 'gwh-compare-col');
      var media = el('a', 'gwh-compare-col__media');
      media.href = safeUrl(p.url || (p.handle ? '/products/' + p.handle : '#'));
      if (p.image) {
        var img = document.createElement('img');
        img.src = safeUrl(p.image);
        img.alt = '';
        img.loading = 'lazy';
        img.width = 400;
        img.height = 500;
        media.appendChild(img);
      }
      col.appendChild(media);

      if (p.vendor) col.appendChild(el('p', 'gwh-compare-col__brand', p.vendor));
      var title = el('a', 'gwh-compare-col__title', p.title || '');
      title.href = safeUrl(p.url || (p.handle ? '/products/' + p.handle : '#'));
      col.appendChild(title);
      if (p.price) col.appendChild(el('p', 'gwh-compare-col__price', p.price));
      col.appendChild(
        el('p', 'gwh-compare-col__avail', p.available === false ? 'Unavailable' : 'Available')
      );

      var actions = el('div', 'gwh-compare-col__actions');
      var view = el('a', 'gwh-compare-col__cta', 'View details');
      view.href = safeUrl(p.url || (p.handle ? '/products/' + p.handle : '#'));
      var rem = el('button', 'gwh-compare-col__remove', 'Remove');
      rem.type = 'button';
      rem.setAttribute('data-gwh-compare-remove', p.handle || '');
      actions.appendChild(view);
      actions.appendChild(rem);
      col.appendChild(actions);
      grid.appendChild(col);
    });
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-gwh-compare-drawer]');
    if (!drawer) return;
    renderDrawer();
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('gwh-compare-drawer-open');
    var panel = drawer.querySelector('.gwh-compare-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-gwh-compare-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('gwh-compare-drawer-open');
  }

  function refresh() {
    syncButtons();
    renderBar();
    var drawer = document.querySelector('[data-gwh-compare-drawer]');
    if (drawer && drawer.classList.contains('is-open')) renderDrawer();
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-gwh-compare-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      event.stopPropagation();
      var result = toggle(itemFromButton(toggleBtn));
      if (result === null) return;
      refresh();
      return;
    }

    if (event.target.closest('[data-gwh-compare-open]')) {
      event.preventDefault();
      if (read().length >= 2) openDrawer();
      return;
    }

    if (event.target.closest('[data-gwh-compare-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.closest('[data-gwh-compare-clear]')) {
      event.preventDefault();
      clear();
      closeDrawer();
      refresh();
      return;
    }

    var removeBtn = event.target.closest('[data-gwh-compare-remove]');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      remove(removeBtn.getAttribute('data-gwh-compare-remove'));
      refresh();
      if (read().length < 2) closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (
            n.nodeType === 1 &&
            (n.matches && n.matches('[data-gwh-compare-toggle]')
              ? true
              : n.querySelector && n.querySelector('[data-gwh-compare-toggle]'))
          ) {
            syncButtons();
            return;
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
